<template>
    <section>
        <div class="grid fixed gap-3 fixed-max-sm xs-grid-cols-1">
            <div class="text-center">
                <template v-if="isSeller">
                    <h2 class="f3 text-bold">Monitor your equity and sell your home with confidence</h2>
                </template>
                <template v-else>
                    <h2 class="f3 text-bold">Tools for every step of your real estate journey with a top agent in {{ glb.geo.city }}</h2>
                </template>
            </div>
            <ul class="tab static-tab tab-pills m-x-auto">
                <li>
                    <a role="button" @click="switchSeller(false)" :class="{active:!isSeller}" >Buyer</a>
                </li>
                <li>
                    <a role="button" @click="switchSeller(true)" :class="{active:isSeller}">Seller</a>
                </li>
            </ul>
            <div class="list-card default-size" v-if="isSeller">
                <mvtShifter ref="shifter" :center="true">
                    <div class="flex large center inline corner bg-default vertical">
                        <b class="f4 text-bold">Home Valuation</b>
                        <p class="multipleline-2 f6">Receive an accurate valuation of your home and identify the best time to sell</p>
                        <a :href="glb.appUrl + 'what-is-your-home-worth/'" class="btn secondary regular">Start Valuation</a>
                    </div>
                    <div class="flex large center inline corner bg-default vertical">
                        <b class="f4 text-bold">Expert Guidance</b>
                        <p class="multipleline-2 f6">Get matched with a local agent and maximize your home sale</p>
                        <button @click="openHotlead('Connect with an Agent')" class="btn secondary regular">Connect with an Agent</button>
                    </div>
                    <div class="flex large center inline corner bg-default vertical">
                        <b class="f4 text-bold">Homeowner Tools</b>
                        <p class="multipleline-2 f6">Monitor your equity and build long-term wealth with Movoto Homeowner</p>
                        <a :href="glb.appUrl + 'homeowner/'" target="_blank" class="btn secondary regular">Try Movoto Homeowner</a>
                    </div>
                    <div class="flex large center inline corner bg-default vertical">
                        <b class="f4 text-bold">Refinance</b>
                        <p class="multipleline-2 f6">Discover how much you can save by lowering your mortgage interest rate</p>
                        <button type="button" @click="show3rdPartyForm('seeRefinanceRate', 'refinance', $event)" class="btn secondary regular">See Refinance Rates</button>
                    </div>
                </mvtShifter>
            </div>
            <div class="list-card static-card-list"  v-else>
                <mvtShifter ref="shifter" :center="true">
                    <div class="flex large center inline corner bg-default vertical">
                        <b class="f4 text-bold">Search Homes</b>
                        <p class="multipleline-2 f6">Find available listings best suited to your needs and preferences</p>
                        <a :href="glb.appUrl + 'for-sale/'" class="btn secondary regular">Start Searching</a>
                    </div>
                    <div class="flex large center inline corner bg-default vertical">
                        <b class="f4 text-bold">Mortgage Tools</b>
                        <p class="multipleline-2 f6">Estimate your monthly payments and discover how much you can afford</p>
                        <a :href="glb.appUrl + 'mortgages/calculator/'" class="btn secondary regular">Mortgage Calculator</a>
                    </div>
                    <div class="flex large center inline corner bg-default vertical">
                        <b class="f4 text-bold">Get Preapproved</b>
                        <p class="multipleline-2 f6">Be prepared to make an offer. Start the mortgage preapproval process</p>
                        <button type="button" @click="show3rdPartyForm('applynow', 'preapprove', $event)" class="btn secondary regular">Apply Now</button>
                    </div>
                    <div class="flex large center inline corner bg-default vertical">
                        <b class="f4 text-bold">Expert Guidance</b>
                        <p class="multipleline-2 f6">Get matched with an experienced top local Real Estate agent near you</p>
                        <button type="button" @click="openHotlead('Connect with an Agent')" class="btn secondary regular">Connect with an Agent</button>
                    </div>
                </mvtShifter>
            </div>
        </div>
    </section>
</template>
<script src="./agent-tourlink.js"></script>
<style lang="scss">
@use "./agent-tourlink.scss" as *;
</style>